import React from "react";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
const Text = ({ text, style, id }) => {
  const messagePaneReducer = useSelector((state) => state.messagePaneReducer);
  return (
    <div
      className={
        Object.values(messagePaneReducer.isChatEnabled).includes(true)
          ? "text opacity-lost-conn"
          : "text"
      }
      style={style}
    >
      {parse(text)}
    </div>
  );
};

export default Text;
